module.exports = __webpack_public_path__ + "static/media/kitchen-2565105_1920.f23551e0.jpg";